
import { useState } from 'react';

export default function About() {
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const handleImageError = () => {
    setImageLoaded(true);
  };

  return (
    <section id="chi-siamo" className="py-12 sm:py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-12 items-center">
          {/* Left Side - Image */}
          <div className="lg:col-span-2">
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/622735eea5af12f2c1023ec4ab458994.jpg"
                alt="Furgone officina mobile Metamorfosi Preparazioni"
                className="w-full h-auto max-h-[400px] sm:max-h-[500px] lg:max-h-none rounded-2xl md:rounded-3xl shadow-xl md:shadow-2xl object-cover object-top"
                onLoad={handleImageLoad}
                onError={handleImageError}
              />
              {!imageLoaded && (
                <div className="absolute inset-0 bg-gray-200 animate-pulse rounded-2xl md:rounded-3xl"></div>
              )}
            </div>
          </div>

          {/* Right Side - Content */}
          <div className="lg:col-span-3">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 md:mb-6">
              Il Meccanico viene da te
            </h2>
            <p className="text-base sm:text-lg text-gray-700 mb-4 md:mb-6 leading-relaxed">
              Sono un <strong>meccanico professionista</strong> con sede a <strong>Paderno Franciacorta</strong>. 
              Offro servizi di <strong>manutenzione auto e moto direttamente a domicilio</strong> in tutta la provincia di Brescia.
            </p>
            <p className="text-base sm:text-lg text-gray-700 mb-4 md:mb-6 leading-relaxed">
              Con <strong>Metamorfosi Preparazioni</strong>, non devi più perdere tempo in officina. 
              <strong> Vengo io da te</strong> con tutta l'attrezzatura necessaria: tagliandi, freni, 
              diagnosi elettronica e manutenzione ordinaria e straordinaria.
            </p>
            <p className="text-base sm:text-lg text-gray-700 mb-6 md:mb-8 leading-relaxed">
              Lavoro nel <strong>tuo garage, parcheggio o cortile</strong>, garantendo professionalità, 
              trasparenza e risparmio di tempo. Copro un raggio di <strong>30 km da Paderno Franciacorta</strong>: 
              Franciacorta, Brescia, Lago d'Iseo, Valtrompia e Bassa Bresciana.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6 mb-6 md:mb-8">
              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#E31E24]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-tools-line text-[#E31E24] text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-base md:text-lg mb-1">
                    Attrezzatura Professionale
                  </h3>
                  <p className="text-sm md:text-base text-gray-600">
                    Strumenti e diagnosi di ultima generazione
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#E31E24]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-[#E31E24] text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-base md:text-lg mb-1">
                    Risparmio di Tempo
                  </h3>
                  <p className="text-sm md:text-base text-gray-600">
                    Niente attese in officina
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#E31E24]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-[#E31E24] text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-base md:text-lg mb-1">
                    Garanzia e Trasparenza
                  </h3>
                  <p className="text-sm md:text-base text-gray-600">
                    Preventivi chiari e lavoro certificato
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3 md:gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-[#E31E24]/10 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-[#E31E24] text-lg md:text-xl"></i>
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-base md:text-lg mb-1">
                    Zona Operativa Ampia
                  </h3>
                  <p className="text-sm md:text-base text-gray-600">
                    30 km da Paderno Franciacorta
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-3 md:gap-4">
              <a
                href="tel:+393518312394"
                className="inline-flex items-center px-6 md:px-8 py-3 md:py-4 bg-[#E31E24] text-white font-semibold rounded-lg hover:bg-[#c41a1f] transition-all duration-300 cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                <i className="ri-phone-line mr-2"></i>
                Chiamami Ora
              </a>
              <a
                href="https://wa.me/393518312394"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 md:px-8 py-3 md:py-4 bg-white text-black font-semibold rounded-lg border-2 border-black hover:bg-gray-50 transition-all duration-300 cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                <i className="ri-whatsapp-line mr-2 text-[#25D366]"></i>
                WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
